module.exports = __webpack_public_path__ + "img/wechattitle.74a3065d.png";